import { Button, DataSource, Label, Layout, Panel, Tab, Table, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutDOEFuelIndex extends Layout {
    buttonRetrieveDOEPrices: Button;
    labelTitle: Label;
    panelHeader: Panel;
    panelMonthly: Panel;
    panelWeekly: Panel;
    sourceFuelPrice: DataSource;
    sourceFuelPriceMonthly: DataSource;
    tabMonthly: Tab;
    tabWeekly: Tab;
    tableMonthly: Table;
    tableWeekly: Table;
    tabsetDOEFuelIndex: Tabset;
}
